module.exports = __webpack_public_path__ + "static/media/Union4.bca6536a.png";